module.exports = __webpack_public_path__ + "static/media/clinical-medication-bg.e4879bd3.png";